// colorUtils.js

// Function to convert hex to RGB
export function hexToRgb(hex) {
    hex = hex?.replace(/^#/, '');
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return { r, g, b };
  }
  
  // Function to convert RGB to hex
  export function rgbToHex(r, g, b) {
    const hex = (r << 16) + (g << 8) + b;
    return `#${hex.toString(16).padStart(6, '0')}`;
  }
  
  // Function to lighten a color
  export function lightenColor(hex, percentage) {
    let { r, g, b } = hexToRgb(hex);
    r = Math.min(255, Math.floor(r + (255 - r) * (percentage / 100)));
    g = Math.min(255, Math.floor(g + (255 - g) * (percentage / 100)));
    b = Math.min(255, Math.floor(b + (255 - b) * (percentage / 100)));
    return rgbToHex(r, g, b);
}
  